





































































































































































import { startCase } from 'lodash';
import { PropType } from 'vue';
import moment from 'moment';
import {
  EmployeeHourlySubType,
  IVacationCarryOverRequest,
  VacationCarryOverRequestStateEnum
} from '@/models';

import ErrorAlert from '../common/ErrorAlert.vue';
import VacationCarryOverRequestDetailMenuCardStateActionButtons from './VacationCarryOverRequestDetailMenuCardStateActionButtons.vue';
import VacationCarryOverApproverList from './VacationCarryOverApproverList.vue';
import VacationCarryOverRequestCommentList from './VacationCarryOverRequestCommentList.vue';

import mixins from '@/utils/mixins';
import SnackbarMixin from '@/mixins/snackbar';
import authMixin from '@/mixins/auth';

import ALDialog from '../core/Dialog/ALDialog.vue';

export default mixins(SnackbarMixin, authMixin).extend({
  components: {
    VacationCarryOverRequestDetailMenuCardStateActionButtons,
    ErrorAlert,
    VacationCarryOverApproverList,
    VacationCarryOverRequestCommentList,
    ALDialog
  },

  props: {
    dialog: Boolean,

    request: {
      type: Object as PropType<IVacationCarryOverRequest>
    },

    canRejectOrApproveState: Boolean,
    canCancel: Boolean
  },
  data() {
    return {
      VacationCarryOverRequestStateEnum,
      EmployeeHourlySubType,
      errorMessage: '',
      errorMessageDetail: ''
    };
  },

  computed: {
    vacationCarryOverStateColor(): string {
      return this.request.getStateInfo().color;
    },
    vacationCarryOverStateDisplayName(): string {
      return this.request.getStateInfo().display_name;
    }
  },

  methods: {
    moment,

    startCase,

    openCommentDialog(state: VacationCarryOverRequestStateEnum) {
      this.$emit('openCommentDialog', state);
    },

    close() {
      this.$forceUpdate();
      this.$emit('close');
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.errorMessageDetail = '';
    },

    setErrorMessage(messages: {
      errorMessage: string;
      errorMessageDetail: string;
    }) {
      this.errorMessage = messages.errorMessage;
      this.errorMessageDetail = messages.errorMessageDetail;
    }
  }
});
